

























import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    handleCommand(command:any) {
        command.item.click()
    }
    get projectTitle(){
        return utils.getStore().title
    }
}
